/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SystemDropdownParameterKind = {
    Boolean: 'Boolean',
    SingleSelect: 'SingleSelect'
} as const;
export type SystemDropdownParameterKind = typeof SystemDropdownParameterKind[keyof typeof SystemDropdownParameterKind];


export function instanceOfSystemDropdownParameterKind(value: any): boolean {
    for (const key in SystemDropdownParameterKind) {
        if (Object.prototype.hasOwnProperty.call(SystemDropdownParameterKind, key)) {
            if (SystemDropdownParameterKind[key as keyof typeof SystemDropdownParameterKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SystemDropdownParameterKindFromJSON(json: any): SystemDropdownParameterKind {
    return SystemDropdownParameterKindFromJSONTyped(json, false);
}

export function SystemDropdownParameterKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownParameterKind {
    return json as SystemDropdownParameterKind;
}

export function SystemDropdownParameterKindToJSON(value?: SystemDropdownParameterKind | null): any {
    return value as any;
}

export function SystemDropdownParameterKindToJSONTyped(value: any, ignoreDiscriminator: boolean): SystemDropdownParameterKind {
    return value as SystemDropdownParameterKind;
}

